import React from 'react'

export default function EmbeddedTimetablePreview() {
  const data = [
    { id: 1, name: 'Yoga', day: 'Monday', timeIn: 930, timeOut: 1030 },
    { id: 2, name: 'Spin Class', day: 'Monday', timeIn: 1800, timeOut: 1845 },
    { id: 3, name: 'Pilates', day: 'Tuesday', timeIn: 700, timeOut: 745 },
    { id: 4, name: 'Box Fit', day: 'Wednesday', timeIn: 1200, timeOut: 1245 },
    { id: 5, name: 'Strength Training', day: 'Thursday', timeIn: 1730, timeOut: 1830 },
    // { id: 6, name: 'Zumba', day: 'Friday', timeIn: 1900, timeOut: 1945 },
  ]

  const order = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']

  const formatTime = (t) => {
    const h24 = Math.floor(t / 100)
    const m = t % 100
    const ampm = h24 >= 12 ? 'pm' : 'am'
    const h12 = h24 % 12 === 0 ? 12 : h24 % 12
    const mStr = m === 0 ? '' : `:${String(m).padStart(2, '0')}`
    return `${h12}${mStr}${ampm}`
  }

  const grouped = order.reduce((acc, day) => {
    acc[day] = data.filter((e) => e.day === day)
    return acc
  }, {})

  return (
    <div className="border rounded p-3 bg-light">
      <div className="d-flex justify-content-between mb-3">
        <button className="btn btn-sm btn-outline-secondary" disabled>
          &lt; Previous
        </button>
        <button className="btn btn-sm btn-outline-secondary" disabled>
          Next &gt;
        </button>
      </div>

      <div className="timetable-grid row g-3">
        {order.map(
          (day) =>
            grouped[day].length > 0 && (
              <div className="col-12 col-md-6" key={day}>
                <div className="border rounded bg-white">
                  <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                    <div className="fw-semibold">{day}</div>
                 
                  </div>
                  <div className="p-3">
                    {grouped[day].map((a) => (
                      <div className="border rounded p-2 mb-2" key={a.id}>
                        <div className="fw-semibold">{a.name}</div>
                        <div className="text-muted mb-2">
                          {formatTime(a.timeIn)} to {formatTime(a.timeOut)}
                        </div>
                        <button className="btn btn-sm btn-outline-primary w-100" disabled>
                          Book now
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
        )}
      </div>
    </div>
  )
}
